module.exports = __webpack_public_path__ + "rectangle_placeholder-644bdc3b301100d62638.png";